<template>
	<section class="member-profile">
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<span>基本信息</span>
				<!-- <el-button style="float: right" type="primary" size="mini">
					编辑
				</el-button> -->
			</div>
			<el-descriptions :column="2" border>
				<el-descriptions-item label="姓名">
					{{ profile.name }}
				</el-descriptions-item>
				<el-descriptions-item label="会员等级">
					{{ profile.level }}
				</el-descriptions-item>
				<el-descriptions-item label="手机号">
					{{ profile.mobile }}
				</el-descriptions-item>
				<el-descriptions-item label="邮箱">
					{{ profile.email }}
				</el-descriptions-item>
				<el-descriptions-item label="所在公司">
					{{ profile.company }}
				</el-descriptions-item>
				<el-descriptions-item label="职位">
					{{ profile.title }}
				</el-descriptions-item>
			</el-descriptions>
		</el-card>

		<el-card shadow="never" style="margin-top: 24px;display: none;">
			<div slot="header" class="clearfix">
				<span>证件信息</span>
				<el-button style="float: right" type="text" size="mini">
					管理证件
				</el-button>
			</div>
			<el-table :data="profile.documents" size="small">
				<el-table-column prop="type" label="证件类型" width="160" />
				<el-table-column prop="number" label="证件号码" min-width="200" />
				<el-table-column prop="expiry" label="有效期" width="160" />
				<el-table-column label="操作" width="120">
					<template slot-scope="{ row }">
						<el-button type="text" size="mini" @click="handleEditDocument(row)">
							更新
						</el-button>
						<el-button type="text" size="mini" @click="handleDeleteDocument(row)">
							删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
	</section>
</template>

<script>
export default {
	name: 'MemberProfile',
	props: {
		snapshot: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		profile() {
			return (
				this.snapshot.profile || {
					name: '游客',
					mobile: '--',
					email: '--',
					company: '--',
					level: '--',
					documents: []
				}
			)
		}
	},
	methods: {
		handleEditDocument(doc) {
			this.$emit('edit-document', doc)
		},
		handleDeleteDocument(doc) {
			this.$emit('delete-document', doc)
		}
	}
}
</script>

<style lang="scss" scoped>
.member-profile {
	.el-card + .el-card {
		margin-top: 24px;
	}
}
</style>

